export const PERMS = {
    READ: 'report_driver_surcharges.read',
    EXPORT: 'report_driver_surcharges.export',
    CREATE: 'report_driver_surcharges.create',
    UPDATE: 'report_driver_surcharges.update',
    DELETE: 'report_driver_surcharges.delete',
}
